const CouponSectionSkeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="p-5 bg-white my-5">
      <div className="px-5 flex justify-between items-center rounded-500">
        <div>
          <div className="w-[160px] h-5 bg-[#f3f3f3] skeleton"></div>
          <div className="w-[80px] h-3 bg-[#f3f3f3] mt-1 skeleton"></div>
        </div>
        <div className="bg-[#f3f3f3] w-[80px] rounded-700 h-8 mt-[2px] shadow-[0px_4px_12px_0px_rgba(0,0,0,0.12),0px_0px_3px_0px_rgba(0,0,0,0.05)] skeleton"></div>
      </div>
    </div>
  );
};

export default CouponSectionSkeleton;
